<template>
    <v-container>
            <br/>

            <template>
                <v-alert class="text-center" :value="!this.$store.state.OBJ_APPLICATION_INIT_LOADED" type="warning" dismissible>{{this.$store.state.STRING_DATA_LOADING}}</v-alert>
                <br/>
            </template>
            
            <hr/>
            OBJ_APPLICATION_INIT_DATE:  {{this.$store.state.OBJ_APPLICATION_INIT_DATE}}
            <hr/>
            OBJ_APPLICATION_INIT_LOADED (records: {{this.$store.state.OBJ_APPLICATION_INIT_LOADED}})
            <hr/>
            <br/>            
            <hr/>
            OBJ_LOADING (records: {{this.$store.state.OBJ_LOADING != null ? this.$store.state.OBJ_LOADING.length : 'null'}})
            <hr/>
            <br/>
            <hr/>
            OBJ_PARLIAMENTS (records: {{this.$store.state.OBJ_PARLIAMENTS != null ? this.$store.state.OBJ_PARLIAMENTS.length:  'null'}})
            <hr/>
            OBJ_PARTIES (records: {{this.$store.state.OBJ_PARTIES != null ? this.$store.state.OBJ_PARTIES.length : 'null'}})
            <hr/>
            OBJ_STATES (records: {{this.$store.state.OBJ_STATES != null ? this.$store.state.OBJ_STATES.length : 'null'}})
            <hr/>
            OBJ_ELECTORATES (records: {{this.$store.state.OBJ_ELECTORATES != null ? this.$store.state.OBJ_ELECTORATES.length : 'null'}})
            <hr/>
            OBJ_PARLIAMENTARIANS (records: {{this.$store.state.OBJ_PARLIAMENTARIANS != null ? this.$store.state.OBJ_PARLIAMENTARIANS.length : 'null'}})
            <hr/>
            OBJ_BIOGRAPHY (records: {{this.$store.state.OBJ_BIOGRAPHY != null ? this.$store.state.OBJ_BIOGRAPHY.length : 'null'}})
            <hr/>
            OBJ_RECORDSOFSERVICE (records: {{this.$store.state.OBJ_RECORDSOFSERVICE != null ? this.$store.state.OBJ_RECORDSOFSERVICE.length : 'null'}})
            <hr/>
            OBJ_COMMITTEES (records: {{this.$store.state.OBJ_COMMITTEES != null ? this.$store.state.OBJ_COMMITTEES.length : 'null'}})
            <hr/>
            OBJ_MINISTRIES (records: {{this.$store.state.OBJ_MINISTRIES != null ?this.$store.state.OBJ_MINISTRIES.length : 'null'}})
            <hr/>
            OBJ_MINISTRYRECORDS (records: {{this.$store.state.OBJ_MINISTRYRECORDS != null ?this.$store.state.OBJ_MINISTRYRECORDS.length : 'null'}})
            <hr/>
            OBJ_SHADOWMINISTRIES (records: {{this.$store.state.OBJ_SHADOWMINISTRIES != null ?this.$store.state.OBJ_SHADOWMINISTRIES.length : 'null'}})
            <hr/>
            OBJ_SHADOWMINISTRYRECORDS (records: {{this.$store.state.OBJ_SHADOWMINISTRYRECORDS != null ?this.$store.state.OBJ_SHADOWMINISTRYRECORDS.length : 'null'}})
            <hr/>
            OBJ_COMMITTEERECORDS (records: {{this.$store.state.OBJ_COMMITTEERECORDS != null? this.$store.state.OBJ_COMMITTEERECORDS.length : 'null'}})
            <hr/>
            OBJ_DISTRIBUTIONS (records: {{this.$store.state.OBJ_DISTRIBUTIONS != null ?this.$store.state.OBJ_DISTRIBUTIONS.length : 'null'}})
            <hr/>
            <br/>
            <hr/>
            OBJ_ERROR (records: {{this.$store.state.OBJ_ERROR.length != null ? this.$store.state.OBJ_ERROR.length : 'null'}}): {{this.$store.state.OBJ_ERROR}}]        
            <hr/>
            <br/><br/>
            

            <v-select 
                label      ="Select a Parliament" 
                v-model    ="PARLIAMENTS_SELECTED"                 
                :items     ="this.$store.getters.GET_PARLIAMENTS" 
                item-text  ="Name" 
                item-value ="PID"                
                multiple small-chips
                v-on:change="FILTER_PARLIAMENTS"  />
            <v-spacer />

            <br/>
            [PARLIAMENT Date(s): {{ Selected_PARLIAMENT }} ]
            <br/><br/>
            [PARLIAMENTS_SELECTED: {{this.PARLIAMENTS_SELECTED}}]
            <br/><br/>
            [DATE_CURRENT_PARLIAMENT: {{ this.$store.state.DATE_CURRENT_PARLIAMENT.DateStart | dateFromTo()}} , {{this.$store.state.DATE_CURRENT_PARLIAMENT.DateEnd | dateFromTo()}}]
            <br/><br/>
            [DATE_CURRENT_PARLIAMENT:{{this.$store.state.DATE_CURRENT_PARLIAMENT}}]
            <br/><br/>

    </v-container>
</template>

<script>
window.scrollTo(0, 0);
export default {     
    
    PHID:         'HK5',
    Selected_PARLIAMENT: [],
    SELECTED_PARLIAMENTS: [],
    PARLIAMENTS_SELECTED:[],
    DateOpeningForCurrentParl:  '',

    GLOBAL_FILTERS: [[]],

    data() {
        return {
            search:       '',
            RECORDS1:     [],
            RECORDS2:     [],
            Selected_PARLIAMENT: [],
            SELECTED_PARLIAMENTS: [],
            PARLIAMENTS_SELECTED:[],
            DateOpeningForCurrentParl:  '',
            filterString: "27",

            GLOBAL_FILTERS:[[]],


            PHID:         'EZ5',
            COMMITTEE:    [],
            CSV_HEADERS:  ['EID','Electorate','State','StateAbbrev','Origin','Established','Ceased'], //+ this.$store.state.STRING_CRLF,
            CSV_FILENAME: "Seans-test-filename",
        }
    },

    methods: {

        FILTER_PARLIAMENTS () {
            // create a function scoped var to hold all Committees
            let OBJ_TEMP = [];
            let index = 0;

            this.GLOBAL_FILTERS[0] =  ['PARLIAMENTS_SELECTED']

            //this.DateOpeningForCurrentParl = this.$store.state.OBJ_PARLIAMENTS.find(OBJ => OBJ.PID == this.$store.state.OBJ_PARLIAMENTS.length).DateOpening
            //
            //  then we progressively filter down from all to just matched records   
            for (index = 0; index < this.PARLIAMENTS_SELECTED.length; ++index) 
            {
                OBJ_TEMP =  OBJ_TEMP.concat( { 
                    'START':this.$store.state.OBJ_PARLIAMENTS.find(OBJ => OBJ.PID == this.PARLIAMENTS_SELECTED[index]).DateElection,
                    'END':this.$store.state.OBJ_PARLIAMENTS.find(OBJ => OBJ.PID == this.PARLIAMENTS_SELECTED[index]).ParliamentEnd 
                } )
               //this.$store.dispatch('PUSH_ERROR', {message: 'help me Obe Wan, your my only hope'} )
               this.GLOBAL_FILTERS['PARLIAMENTS_SELECTED'].push({foo: 'bar'}) 
               
            }

            this.Selected_PARLIAMENT = OBJ_TEMP;


            //
            // then simply return the object item count
             return true;   //OBJ_records.length
        },

    },
}
</script>
